import React, { useEffect, useState } from 'react';
import {
  FaMapMarkerAlt,
  FaFlag,
  FaUsers,
  FaIdBadge,
  FaChartLine,
  FaCalendarAlt,
} from 'react-icons/fa';
import {
  ProfileHeader as Header,
  ProfileTitle,
  ProfileInfo,
  ProfileImageContainer,
  ProfileImage,
  ProfileDetails,
  ProfileName,
  ProfileBio,
  ProfileMetaList,
  ProfileMetaItem,
  MetaIcon,
  StatStrip,
  StatBlock,
  StatLabel,
  StatValue,
  StatDelta,
  ClassificationPills,
  ClassificationPill,
  StatusDot,
} from './styles';
import { listSocialProfiles } from '../../services/platformService';

function formatCount(n) {
  if (n == null || !Number.isFinite(n)) return '—';
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (n >= 1_000) return (n / 1_000).toFixed(2).replace(/\.?0+$/, '') + 'K';
  return String(n);
}

const ProfileHeader = () => {
  const [totals, setTotals] = useState({ loading: true, sumFollowers: null, profileCount: 0 });

  useEffect(() => {
    let cancelled = false;
    listSocialProfiles()
      .then((profiles) => {
        if (cancelled) return;
        const own = (profiles || []).filter((p) => p.is_own === true);
        const sum = own.reduce((acc, p) => {
          const f = p.latest?.followers;
          return Number.isFinite(f) ? acc + f : acc;
        }, 0);
        setTotals({
          loading: false,
          sumFollowers: sum > 0 ? sum : null,
          profileCount: own.length,
        });
      })
      .catch(() => {
        if (!cancelled) setTotals({ loading: false, sumFollowers: null, profileCount: 0 });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Header>
      <ProfileTitle>Perfil Político · Dossier</ProfileTitle>

      <ProfileInfo>
        <ProfileImageContainer>
          <ProfileImage
            src="/img/chouhy.jpg"
            alt="Federico Chouhy"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        </ProfileImageContainer>

        <ProfileDetails>
          <ProfileName>Federico Chouhy</ProfileName>

          <ClassificationPills>
            <ClassificationPill>
              <StatusDot style={{ marginRight: 6, verticalAlign: 'middle' }} />
              Mandato 2025–2029
            </ClassificationPill>
            <ClassificationPill>Cluster: LLA-BA</ClassificationPill>
            <ClassificationPill>Tier: Local · Legislativo</ClassificationPill>
            <ClassificationPill>Próxima cita: 2027 · Mid-term</ClassificationPill>
          </ClassificationPills>

          <ProfileBio>
            Empresario y dirigente político de San Nicolás. Concejal por La Libertad Avanza
            tras las elecciones legislativas de octubre 2025, en alianza con Primero San
            Nicolás. Director titular de MoviPort S.A. y presidente de la Fundación MoviPort.
            Su agenda combina libertad económica, infraestructura portuaria y transparencia
            municipal.
          </ProfileBio>

          <ProfileMetaList>
            <ProfileMetaItem>
              <MetaIcon><FaMapMarkerAlt /></MetaIcon>
              San Nicolás de los Arroyos, Buenos Aires
            </ProfileMetaItem>
            <ProfileMetaItem>
              <MetaIcon><FaFlag /></MetaIcon>
              La Libertad Avanza · alianza con Primero San Nicolás
            </ProfileMetaItem>
            <ProfileMetaItem>
              <MetaIcon><FaUsers /></MetaIcon>
              Concejal en ejercicio (mandato 2025–2029)
            </ProfileMetaItem>
            <ProfileMetaItem>
              <MetaIcon><FaIdBadge /></MetaIcon>
              ID interno: FCH-0001
            </ProfileMetaItem>
          </ProfileMetaList>
        </ProfileDetails>
      </ProfileInfo>

      <StatStrip>
        <StatBlock>
          <StatLabel>Seguidores totales (perfiles oficiales)</StatLabel>
          <StatValue>
            {totals.loading ? '…' : formatCount(totals.sumFollowers)}
            {!totals.loading && totals.profileCount > 0 && (
              <StatDelta>{totals.profileCount} redes</StatDelta>
            )}
          </StatValue>
        </StatBlock>
        <StatBlock>
          <StatLabel>Temas activos</StatLabel>
          <StatValue>09</StatValue>
        </StatBlock>
        <StatBlock>
          <StatLabel>Propuestas publicadas</StatLabel>
          <StatValue>05</StatValue>
        </StatBlock>
        <StatBlock>
          <StatLabel>
            <FaChartLine style={{ marginRight: 4 }} />
            Resultado legislativas 2025
          </StatLabel>
          <StatValue>
            Concejal electo
            <StatDelta>LLA · San Nicolás</StatDelta>
          </StatValue>
        </StatBlock>
        <StatBlock>
          <StatLabel>
            <FaCalendarAlt style={{ marginRight: 4 }} />
            Próxima elección
          </StatLabel>
          <StatValue>2027</StatValue>
        </StatBlock>
      </StatStrip>
    </Header>
  );
};

export default ProfileHeader;
